import * as React from 'react';
import { TextField, Grid, Tooltip } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import ImageAvatars from "./image-avatar-component";
import Autocomplete from '@mui/material/Autocomplete';
import { useSelector, useDispatch } from "react-redux";
import { setAdminLocationInfo, setcityError, setthrowInvalidZipcodeError_Admin, fetchState, fetchCities, setCountryCode } from "../reducers/global-reducer";
import { Visibility, InfoOutlined } from "@mui/icons-material";
import { Warning } from '@mui/icons-material';
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';
import { useTranslate } from 'react-redux-multilingual';
import RunScript from './RunScript';
import DOMPurify from 'dompurify';

const alertStyling1 = { color: 'red', fontSize: '35px', position: 'absolute', top: '13px', right: '-70px' }
const alertStyling2 = { color: 'red', fontSize: '35px', position: 'absolute', top: '13px', left: '-33px' }
const AdminInformation = ({ formik, route }) => {
    const t = useTranslate();
    const [passwordVisible, setpasswordVisible] = React.useState(false);
    const [confirmPasswordVisible, setconfirmPasswordVisible] = React.useState(false);
    const [paramId, setParamId] = React.useState()
    const matches = useMediaQuery('(min-width:500px)');
    const store = useSelector(state => state);
    const dispatch = useDispatch();
    const {
        adminLocationInfo,
        imageUrlAdmin,
        countryDataArray,
        externalAuthUserData,
        countriesArray,
        cityError,
        throwInvalidZipcodeError_Admin,
        stateData,
        stateArray,
        cityArray,
        handleBackButtonConditionForScriptExecution
    } = store.globalreducer

    const { CountryId, StateId, CityId, } = adminLocationInfo
    const [initialCountry, setInitialCountry] = React.useState(false);
    const [initialState, setInitialStete] = React.useState(false);
    const [initialCity, setInitialCity] = React.useState(false);
    const PasswordVisibleHandler = () => setpasswordVisible(!passwordVisible)
    const ConfirmPasswordVisibleHandler = () => setconfirmPasswordVisible(!confirmPasswordVisible)


    // Sanitize Input Before Setting State
    const sanitizeInput = (input) => DOMPurify.sanitize(input);

    const handleCountryName = (value, e) => {
        setInitialCountry(true);
        const sanitizedValue = sanitizeInput(value); // sanitize country value
        dispatch(setAdminLocationInfo({ ...adminLocationInfo, "CountryId": sanitizedValue }));
        const CountryId = countryDataArray.filter(item => item.countryname === sanitizedValue).map(item => item.countryid);
        const conCode = countryDataArray.filter(item => item.countryname === sanitizedValue).map(item => item.countrycode);
        setParamId(CountryId);
        const data = {
            "CountryId": CountryId,
            "multilingualMessage": t
        };
        dispatch(fetchState(data));
        dispatch(setCountryCode(conCode[0]));
    }

    React.useEffect(() => {
        if (CountryId === null || initialCountry) {
            dispatch(setAdminLocationInfo({ ...adminLocationInfo, StateId: "", CityId: "", }))
            formik.values.ZipCode = "";
            setInitialCountry(false)
        }
    }, [CountryId])

    React.useEffect(() => {
        if (StateId === null || initialState) {
            dispatch(setAdminLocationInfo({ ...adminLocationInfo, CityId: "", ZipCode: "" }))
            formik.values.ZipCode = "";
            setInitialStete(false)
        }
    }, [StateId])

    React.useEffect(() => {
        if (CityId === null || initialCity) {
            formik.values.ZipCode = "";
            setInitialCity(false)
        }
    }, [CityId])



    // handle state name 
    const handleStateName = (value) => {
        setInitialStete(true);
        const sanitizedValue = sanitizeInput(value); // sanitize state value
        dispatch(setAdminLocationInfo({ ...adminLocationInfo, "StateId": sanitizedValue }));
        const states = stateData.filter(item => item.statename === sanitizedValue).map(item => item.stateid).map(item => item)[0];
        const tem = paramId[0];
        dispatch(fetchCities(tem, Number(states), t));
    }

    // handle  city name 
    const handleCityName = (value, path) => {
        setInitialCity(true);
        const sanitizedValue = sanitizeInput(value); // sanitize city value
        if (!sanitizedValue) {
            dispatch(setAdminLocationInfo({ ...adminLocationInfo, "CityId": "" }));
            return;
        }
        if (cityError) {
            dispatch(setcityError(false));
        }
        dispatch(setAdminLocationInfo({ ...adminLocationInfo, "CityId": sanitizedValue }));
    }

    const handleFirstName = (e) => {
        const sanitizedValue = sanitizeInput(e.target.value); // sanitize first name
        formik.setFieldValue("firstName", sanitizedValue);
    }

    const handleChangeZipcode = (e) => {
        dispatch(setthrowInvalidZipcodeError_Admin(false));
        const sanitizedValue = sanitizeInput(e.target.value).replace(/[^0-9]/g, ""); // Allow only numbers
        dispatch(setAdminLocationInfo({ ...adminLocationInfo, ZipCode: sanitizedValue }));
        formik.setFieldValue("ZipCode", sanitizedValue);
    }

    // handle designation name
    const handleDesignationChange = (e) => {
        const sanitizedValue = sanitizeInput(e.target.value); // sanitize designation value
        formik.setFieldValue("designation", sanitizedValue);
    };

    // handle address1 change
    const handleAddress1Change = (e) => {
        const sanitizedValue = sanitizeInput(e.target.value); // sanitize address1 value
        formik.setFieldValue("address1", sanitizedValue);
    };

    // handle address2 change
    const handleAddress2Change = (e) => {
        const sanitizedValue = sanitizeInput(e.target.value); // sanitize address2 value
        formik.setFieldValue("address2", sanitizedValue);
    };


    const passReg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;

    return (
        <form noValidate >
            <RunScript value={handleBackButtonConditionForScriptExecution} />
            {/* Add user profile image */}
            <ImageAvatars route={route} srcFile={imageUrlAdmin} />
            <Grid container
                className='username-grid'
            >
                {/* First name */}
                <TextField
                    sx={{ margin: '7px', width: `${matches ? '33rem' : '16rem'}` }}
                    label={t('username')}
                    required title={t('tooltip_name')}
                    id="firstName"
                    name="firstName"
                    value={formik.values.firstName}
                    onChange={handleFirstName}
                    error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                    helperText={formik.touched.firstName && formik.errors.firstName}
                    autoComplete="given-name"
                    disabled={route === "existingUser" ? true : false}
                    inputProps={{ maxLength: 150 }}
                    InputLabelProps={{
                        sx: {
                            '& .MuiFormLabel-asterisk': {
                                color: 'red',
                            },
                        },
                        '&.MuiInputLabel-shrink': {
                            fontSize: '1.5rem', // Works when label shrinks (i.e., floats)
                        },
                        transition: 'all 0.2s ease', // Make it a bit bigger when focused

                    }}
                />
            </Grid>

            <Grid container className='password-grid'>
                {
                    externalAuthUserData.ssotype === "jodosso" &&
                    <>
                        <div style={{ position: 'relative' }}>
                            {
                                // setpassword
                                <TextField
                                    sx={{ margin: '7px', width: '16rem' }}
                                    label={t('setPassword')}
                                    onChange={formik.handleChange}
                                    value={formik.values.Password}
                                    required title={t('tooltip_password')}
                                    id="Password"
                                    name="Password"
                                    autoComplete="new-password"
                                    type={passwordVisible ? "text" : "password"}
                                    error={formik.touched.Password && Boolean(formik.errors.Password)}
                                    helperText={(formik.touched.Password && formik.errors.Password)}
                                    inputProps={{ maxLength: 150 }}
                                    InputLabelProps={{
                                        sx: {
                                            '& .MuiFormLabel-asterisk': {
                                                color: 'red',
                                            },
                                        },
                                        '&.MuiInputLabel-shrink': {
                                            fontSize: '1.5rem', // Works when label shrinks (i.e., floats)
                                        },
                                        transition: 'all 0.2s ease', // Make it a bit bigger when focused

                                    }}
                                />
                            }

                            {
                                <Visibility onMouseEnter={PasswordVisibleHandler} onMouseLeave={PasswordVisibleHandler} className='visibility' />
                            }
                        </div>
                        <div style={{ position: 'relative' }}>
                            {
                                // confirm password
                                <TextField
                                    sx={{ margin: '7px', width: '16rem' }}
                                    label={t('confirmPassword')}
                                    required title={t('tooltip_confirmpassword')}
                                    value={formik.values.confirmPassword}
                                    id="confirmPassword"
                                    name="confirmPassword"
                                    autoComplete="new-password"
                                    onChange={formik.handleChange}
                                    type={confirmPasswordVisible ? "text" : "password"}
                                    error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
                                    helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
                                    inputProps={{ maxLength: 150 }}
                                    InputLabelProps={{
                                        sx: {
                                            '& .MuiFormLabel-asterisk': {
                                                color: 'red',
                                            },
                                        },
                                        '&.MuiInputLabel-shrink': {
                                            fontSize: '1.5rem', // Works when label shrinks (i.e., floats)
                                        },
                                        transition: 'all 0.2s ease', // Make it a bit bigger when focused

                                    }}
                                />
                            }

                            {
                                // hide & Show password
                                <Visibility onMouseEnter={ConfirmPasswordVisibleHandler} onMouseLeave={ConfirmPasswordVisibleHandler} className='visibility' />
                            }
                            <Tooltip title={
                                <p>{t('passwordRule1')}
                                    <br /><br />
                                    {t('passwordRule2')}
                                </p>}>
                                <InfoOutlined className='info-outlied' />
                            </Tooltip>
                            {(formik.values.confirmPassword.length !== 0) && (formik.values.Password !== formik.values.confirmPassword ?
                                <Tooltip title={t('passwordmatchAlert')}>
                                    <Warning sx={matches ? alertStyling1 : alertStyling2} />
                                </Tooltip>
                                : null)
                            }
                            {
                                ((formik.values.Password.length !== 0 && formik.values.confirmPassword.length !== 0) &&
                                    (formik.values.Password.length >= 8) &&
                                    (passReg.test(formik.values.Password)) &&
                                    (formik.values.Password !== formik.values.confirmPassword ?
                                        <Tooltip title={t('passwordmatchAlert')}>
                                            <Warning sx={matches ? alertStyling1 : alertStyling2} />
                                        </Tooltip>
                                        :
                                        <Tooltip title={t('passwordmatchSuccess')}>
                                            <DoneOutlinedIcon className='done-outlinedIcon' />
                                        </Tooltip>))
                            }

                        </div>
                    </>
                }
            </Grid>

            <Grid container className='password-grid'>
                {/* designation */}

                <TextField
                    sx={{ margin: '7px', width: `${matches ? '33rem' : '16rem'}` }}
                    label={t('designation')}
                    name='designation'
                    id="designation"
                    value={formik.values.designation}
                    onChange={handleDesignationChange} // Use sanitized handler
                    error={formik.touched.designation && Boolean(formik.errors.designation)}
                    helperText={formik.touched.designation && formik.errors.designation}
                    disabled={route === "existingUser" ? true : false}
                    inputProps={{ maxLength: 150 }}
                />
            </Grid>
            <Grid container justifyContent={'center'}>
                {/* Country */}
                <Autocomplete
                    options={countriesArray}
                    filterOptions={(countriesArray, state) => {
                        const inputValue = state.inputValue.toLowerCase();
                        return countriesArray.filter(option =>
                            option.toLowerCase().startsWith(inputValue)
                        );
                    }}
                    isOptionEqualToValue={(option, value) => option === value}
                    onChange={(e, v) => handleCountryName(v, e)}
                    value={CountryId}
                    disabled={(route === "existingUser" ? true : false)}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            sx={{ margin: '7px', textAlign: 'left', width: '16rem' }}
                            label={t('country')}
                            fullWidth={false}
                            required title={t('tooltip_country')}
                            disabled={(route === "existingUser" ? true : false)}
                            autoComplete={false}
                            error={formik.touched.country && String(formik.errors.country)}
                            helperText={formik.touched.country && formik.errors.country}
                            InputLabelProps={{
                                sx: {
                                    '& .MuiFormLabel-asterisk': {
                                        color: 'red',
                                    },
                                },
                                '&.MuiInputLabel-shrink': {
                                    fontSize: '1.5rem', // Works when label shrinks (i.e., floats)
                                },
                                transition: 'all 0.2s ease', // Make it a bit bigger when focused

                            }}
                        />
                    )}
                />

                {/* State */}
                <Autocomplete
                    options={stateArray}
                    filterOptions={(stateArray, state) => {
                        const inputValue = state.inputValue.toLowerCase();
                        return stateArray.filter(option =>
                            option.toLowerCase().startsWith(inputValue)
                        );
                    }}
                    onChange={(e, v) => handleStateName(v)}
                    disabled={(route === "existingUser" ? true : false) || CountryId === ""}
                    value={StateId}
                    isOptionEqualToValue={(option, value) => option === value}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            sx={{ margin: '7px', textAlign: 'left', width: '16rem' }}
                            label={t('state')}
                            fullWidth={false}
                            required title={t('tooltip_state')}
                            disabled={(route === "existingUser" ? true : false) || CountryId === ""}
                            autoComplete={false}
                            error={formik.touched.country && String(formik.errors.country)}
                            helperText={formik.touched.country && formik.errors.country}
                            InputLabelProps={{
                                sx: {
                                    '& .MuiFormLabel-asterisk': {
                                        color: 'red',
                                    },
                                },
                                '&.MuiInputLabel-shrink': {
                                    fontSize: '1.5rem', // Works when label shrinks (i.e., floats)
                                },
                                transition: 'all 0.2s ease', // Make it a bit bigger when focused

                            }}
                        />
                    )}
                />
            </Grid>
            <Grid container justifyContent={'center'}>
                {/* City */}
                <Autocomplete
                    options={cityArray}
                    filterOptions={(cityArray, state) => {
                        const inputValue = state.inputValue.toLowerCase();
                        return cityArray.filter(option =>
                            option.toLowerCase().startsWith(inputValue)
                        );
                    }}
                    onChange={(e, v) => handleCityName(v, "autoComplete")}
                    isOptionEqualToValue={(option, value) => option === value}
                    value={CityId}
                    disabled={(route === "existingUser" ? true : false) || StateId === ""}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            sx={{ margin: '7px', textAlign: 'left', width: '16rem' }}
                            label={t('city')}
                            fullWidth={false}
                            value={CityId}
                            disabled={(route === "existingUser" ? true : false) || StateId === ""}
                            autoComplete={false}
                            error={cityError}
                            helperText={cityError ? t('firstName_lastName_RegexValidation') : ""}
                        />
                    )}
                />
                {/* pincode */}
                <TextField
                    sx={{ margin: '7px', width: '16rem' }}
                    label={t('zipcode')}
                    value={formik.values.ZipCode}
                    name="ZipCode"
                    id="ZipCode"
                    onChange={handleChangeZipcode}
                    error={(formik.touched.ZipCode && Boolean(formik.errors.ZipCode)) || throwInvalidZipcodeError_Admin}
                    helperText={(formik.touched.ZipCode && formik.errors.ZipCode || throwInvalidZipcodeError_Admin && t('zipcodeErrorMessage'))}
                    disabled={route === "existingUser" ? true : false || CountryId === ""}
                    autoComplete={false}
                    inputProps={{ maxLength: 150 }}
                />
            </Grid>
            <div className='password-grid'>
                {/* Address1 */}
                <TextField
                    sx={{ margin: '7px', width: `${matches ? '33rem' : '16rem'}` }}
                    label={t('address1')}
                    id='address1'
                    name='address1'
                    fullWidth={false}
                    value={formik.values.address1}
                    onChange={handleAddress1Change}
                    error={formik.touched.address1 && Boolean(formik.errors.address1)}
                    helperText={formik.touched.address1 && formik.errors.address1}
                    disabled={route === "existingUser" ? true : false}
                    autoComplete={false}
                    inputProps={{ maxLength: 250 }}
                />
            </div>
            <div className='password-grid'>
                {/* Address2 */}
                <TextField
                    sx={{ margin: '7px', width: `${matches ? '33rem' : '16rem'}` }}
                    label={t('address2')}
                    id='address2'
                    name='address2'
                    fullWidth={false}
                    value={formik.values.address2}
                    onChange={handleAddress2Change}
                    error={formik.touched.address2 && Boolean(formik.errors.address2)}
                    helperText={formik.touched.address2 && formik.errors.address2}
                    disabled={route === "existingUser" ? true : false}
                    autoComplete={false}
                    inputProps={{ maxLength: 250 }}

                />
            </div>
        </form>
    )
}

export default AdminInformation;